import apiGlobal from 'global/api.global';
import { RootState } from 'index';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Label, Row, Col, Button } from 'reactstrap';

const N2CorrectionPartial = () => {
    /** State variables */
    const [tableDetails, setTableDetails] = useState({
        size: 4,
        index: 0,
        n2Correction: []
    });
    const [count, setCount] = useState(0);
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    /** State variables end */

    /** useEffect start */
    useEffect(() => {
        loadData();
    }, [VesselID])
    /** useEffect end */

    /** Load N2 corrections of selected vessel that are already approved */
    const loadData = async () => {
        await apiGlobal.get(`n2_correction_value/get_n2_correction_by_vessel/?vessel_id=${VesselID}`).then(response => {
            setTableDetails(prevDetails => ({
                ...prevDetails,
                n2Correction: response.data
            }));
            setCount(count => count + 1);
        }).catch(err => {
            setTableDetails(prevDetails => ({
                ...prevDetails,
                n2Correction: []
            }));
        })
    };

    /** Pagination previous */
    const handlePrevPageClick = (e: any) => {
        tableDetails.index = (tableDetails?.index > 0) ? tableDetails?.index - 1 : 0;
        setCount(count + 1);
    }

    /** Pagination next */
    const handleNextPageClick = (e: any) => {
        tableDetails.index = (tableDetails?.index < (Math.ceil(tableDetails?.n2Correction?.length / tableDetails?.size) - 1)) &&
            tableDetails?.index + 1
        setCount(count + 1);
    }

    return (
        <>
            {tableDetails?.n2Correction?.length === 0 ? <Label>No N<sub>2</sub> corrections are approved for this vessel</Label> :
                <>
                    <Row className='mb-3'>
                        <Col lg={12}>
                            <div className="table-responsive">
                                <table className="table mb-0" key={count}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Voyage Number</th>
                                            <th>Duration</th>
                                            <th>Departure port</th>
                                            <th>Arrival port</th>
                                            <th>N<sub>2</sub> correction value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableDetails && tableDetails?.n2Correction?.slice(tableDetails?.index * tableDetails?.size,
                                            tableDetails?.index * tableDetails?.size + tableDetails?.size)?.map((n2: any, index: number) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{n2?.voyage_number}</td>
                                                        <td>{n2?.start_date?.toString().substring(0, 10)}&nbsp;
                                                            {n2?.start_date?.toString().substring(11, 16)}&nbsp;&nbsp;to&nbsp;&nbsp;
                                                            {n2?.end_date?.toString().substring(0, 10)}&nbsp;
                                                            {n2?.end_date?.toString().substring(11, 16)}
                                                        </td>
                                                        <td>{n2?.departure_port}</td>
                                                        <td>{n2?.arrival_port}</td>
                                                        <td>{n2?.correction_value}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={{ size: 2, offset: 10 }} className='mt-3'>
                            <Button type='button' color='primary' className='btn pos-end' onClick={(e: any) => handleNextPageClick(e)}>
                                <i className="bx bx-chevron-right" />
                            </Button>
                            <Button type='button' color='primary' className='btn ms-5' onClick={(e: any) => handlePrevPageClick(e)}>
                                <i className="bx bx-chevron-left" />
                            </Button>
                        </Col>
                    </Row>
                </>
            }
        </>
    )
}

export default N2CorrectionPartial